// extracted by mini-css-extract-plugin
export var checkmark = "features-list-module--checkmark--43c93";
export var featuresList = "features-list-module--featuresList--a4f92";
export var listText = "features-list-module--listText--e1057";
export var xmark = "features-list-module--xmark--f1bcb";